<script>
	import Multiselect from "vue-multiselect";
	import { query } from "@sinao/core-js";

	export default {
		components: { Multiselect },
		props: {
			operationId: {
				type: String,
				required: true
			},
			value: {
				type: null,
				required: true
			},
			data: {
				type: Array,
				required: true,
				default: null
			},
			placeholder: {
				type: String,
				required: true
			},
			textField: {
				type: String,
				required: true
			},
			imageField: {
				type: String,
				required: false,
				default: ""
			},
			fieldsToMap: {
				type: Array,
				required: false,
				default: () => []
			}
		},
		data() {
			return {
				option: null,
				copyOption: null,
        editFields: false,
        initial_option: null
			};
		},
		computed: {
			displayFields() {
				return this.fieldsToMap.filter(item => typeof item.display == "undefined" || item.display);
			},
			monitor() {
				return {
					data: this.data,
					value: this.value
				};
			}
		},
		watch: {
			monitor: {
				handler() {
          if (this.data && this.data.length > 0 && this.value?.id) {
            this.option = this.data.find(e => e.id == this.value.id);
            if (this.initial_option === null) {
              this.initial_option = {...this.option}
            }

					}
				},
				deep: true,
				immediate: true
			},
			option() {
				this.$emit("input", this.option);
			}
  },
		methods: {
			saveOption(selectedOption) {
				this.copyOption = selectedOption;
			},
			updateOption() {
				this.editFields = false;
				this.copyOption = { ...this.option };

				query({
					operationId: this.$props.operationId,
					params: {
						id: this.copyOption.id,
						appId: this.$store.state.app.id
					},
					data: {
						...this.copyOption
					}
				});
			},
      resetOption() {
        Object.keys(this.initial_option).forEach(key => this.option[key] = this.initial_option[key])
        this.editFields = false;
			},
			getImageLink(item) {
				const _item = item && item.image ? item.image : item;

				if (_item) {
					if (_item.slice(0, 1) === "/") {
						return `https://sinao.app${_item}`;
					}

					return _item;
				}

				return null;
			},
			remove() {
				this.option = null;
				this.editFields = false;
			}
		}
	};
</script>

<template>
  <b-row style="padding: 10px 5px">
    <b-col cols="12">
      <div v-if="!option">
        <!-- Select -->
        <Multiselect
          v-model="option"
          :placeholder="placeholder"
          :options="data"
          :show-labels="false"
          :label="textField"
          :track-by="textField"
          :option-height="104"
          @select="saveOption"
        >
          <template #noOptions>
            {{ $t("La liste est vide.") }}
          </template>

          <!-- Option after selection -->
          <template
            slot="singleLabel"
            slot-scope="props"
          >
            <b-img-lazy
              v-if="imageField"
              :src="getImageLink(props.option[imageField])"
              class="option__image"
            />
            <span class="option__desc">
              <span class="option__title">{{ props.option[textField] }}</span>
            </span>
          </template>

          <!-- Options on the select -->
          <template
            slot="option"
            slot-scope="props"
          >
            <b-img-lazy
              v-if="imageField"
              :src="getImageLink(props.option[imageField])"
              class="option__image"
            />
            <div class="option__desc">
              <span class="option__title">{{ props.option[textField] }}</span>
            </div>
          </template>
        </Multiselect>

        <slot name="button" />
      </div>

      <!-- Mapping of the fields -->
      <div v-else-if="displayFields.length > 0 && editFields === false">
        <b-tr
          v-for="(field, index) in displayFields"
          :key="index"
        >
          <b-td
            v-if="field.rename"
            class="align-middle py-1 pl-3 text-muted"
          >
            {{ field.rename }}
          </b-td>
          <b-td class="align-middle pl-3 py-1">
            {{ option[field.key] }}
          </b-td>
        </b-tr>
      </div>

      <!-- Field edition -->
      <b-row
        v-else
        class="mx-0"
      >
        <b-table-simple class="w-100">
          <b-tbody>
            <b-tr
              v-for="(field, index) in fieldsToMap"
              :key="index"
            >
              <b-td class="align-middle py-1 text-muted">
                {{ field.rename }}
              </b-td>
              <b-td class="align-middle py-1">
                <b-form-input
                  v-model.lazy="option[field.key]"
                  :placeholder="field.rename"
                  class="billing__input billing__input--solid"
                />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-button-group
          class="mt-2 w-100"
          size="sm"
        >
          <s-button
            type="border"
            class="mr-2"
            @click="resetOption"
          >
            {{ $t("Annuler") }}
          </s-button>
          <s-button
            type="success"
            class="ml-2"
            @click="updateOption"
          >
            {{ $t("Enregistrer") }}
          </s-button>
        </b-button-group>
      </b-row>

      <b-row class="edit_baseSelect">
        <b-col
          cols="6"
          style="padding-left: 20px"
        >
          <b-button
            v-if="option && editFields === false"
            style="font-size: 12px"
            variant="link"
            @click="editFields = true"
          >
            <b-icon icon="pencil" /> {{ $t("Modifier") }}
          </b-button>
        </b-col>

        <b-col
          cols="6"
          style="padding-left: 70px; margin-left: auto"
        >
          <b-button
            v-if="option && editFields === false"
            style="font-size: 12px"
            variant="link"
            @click="remove"
          >
            <b-icon icon="x" /> {{ $t("Retirer") }}
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
	@import "../../scss/multiselect.scss";
</style>

<style lang="scss" scoped>
	table.b-table {
		td {
			border: none;
		}

		margin-bottom: 0;
	}

	.editButton {
		position: absolute;
		right: 0;
		top: 1em;
	}

	.btn-block + .btn-block {
		margin-top: 0;
	}

  @media screen and (max-width: 768px) {
    .edit_baseSelect {
      flex-wrap: nowrap;
      .col-6 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }
</style>
